import { render, staticRenderFns } from "./WhatIfControl.vue?vue&type=template&id=65235ad7&scoped=true"
import script from "./WhatIfControl.vue?vue&type=script&lang=js"
export * from "./WhatIfControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65235ad7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65235ad7')) {
      api.createRecord('65235ad7', component.options)
    } else {
      api.reload('65235ad7', component.options)
    }
    module.hot.accept("./WhatIfControl.vue?vue&type=template&id=65235ad7&scoped=true", function () {
      api.rerender('65235ad7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/controls/WhatIfControl.vue"
export default component.exports